import { createRouter, createWebHistory } from "vue-router";
import Home from "@/views/Home.vue";
import ProjectDetail from "@/views/ProjectDetail.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/project/:category/:slug",
    name: "ProjectDetail",
    component: ProjectDetail,
    props: true,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    console.log(to.name);

    if (savedPosition) {
      return savedPosition;
    } else if (to.name === "Home") {
      // Try to restore scroll position from sessionStorage
      const scrollPos = sessionStorage.getItem("homeScrollPosition");
      if (scrollPos) {
        setTimeout(() => {
          window.scrollTo(0, parseInt(scrollPos));
        }, 400);
        setTimeout(() => {
          window.scrollTo(0, parseInt(scrollPos));
        }, 350);
        setTimeout(() => {
          window.scrollTo(0, parseInt(scrollPos));
        }, 300);
        return { top: parseInt(scrollPos) };
      }
    }
    return { top: 0 };
  },
});

export default router;
